import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { PageHeader } from "./ServiceDetail";
import { Reveal } from "../components/ui-kit";
import { IMAGES } from "../data/content";

const MEDIA = [
  { src: IMAGES.weddingRoom, cat: "Mariage" },
  { src: IMAGES.djMix, cat: "Soirée" },
  { src: IMAGES.sax, cat: "Musique live" },
  { src: IMAGES.dining, cat: "Mariage" },
  { src: IMAGES.djMic, cat: "Soirée" },
  { src: IMAGES.heroBand, cat: "Concert" },
  { src: IMAGES.mixer, cat: "Matériel" },
];
const FILTERS = ["Tous", "Mariage", "Soirée", "Musique live", "Concert", "Matériel"];

export default function Galerie() {
  const [filter, setFilter] = useState("Tous");
  const [lightbox, setLightbox] = useState(null);
  const shown = filter === "Tous" ? MEDIA : MEDIA.filter((m) => m.cat === filter);

  return (
    <div data-testid="galerie-page">
      <PageHeader overline="Galerie" title="Ambiances & inspirations" subtitle="Un aperçu de notre univers. Les photos et vidéos réelles de nos prestations seront ajoutées prochainement — ces visuels sont des inspirations d'ambiance." />
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex flex-wrap gap-3 mb-10">
            {FILTERS.map((f) => (
              <button key={f} onClick={() => setFilter(f)} data-testid={`gallery-filter-${f}`}
                className={`px-5 py-2 rounded-full text-sm transition-colors duration-300 ${filter === f ? "bg-gold text-background" : "glass text-foreground/80 hover:text-gold"}`}>
                {f}
              </button>
            ))}
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
            {shown.map((m, i) => (
              <Reveal key={m.src} delay={i * 0.05}>
                <button onClick={() => setLightbox(m.src)} className="block w-full overflow-hidden rounded-xl group" data-testid="gallery-item">
                  <img src={m.src} alt={m.cat} loading="lazy" className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <AnimatePresence>
        {lightbox && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-testid="lightbox">
            <button className="absolute top-6 right-6 text-white p-2" aria-label="Fermer"><X size={30} /></button>
            <img src={lightbox} alt="Aperçu" className="max-h-[85vh] max-w-full rounded-xl" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
